import { render, staticRenderFns } from "./GenresIndexList.vue?vue&type=template&id=22afe160&scoped=true&"
import script from "./GenresIndexList.vue?vue&type=script&lang=js&"
export * from "./GenresIndexList.vue?vue&type=script&lang=js&"
import style0 from "./GenresIndexList.vue?vue&type=style&index=0&id=22afe160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afe160",
  null
  
)

export default component.exports